import { httpClient } from '@/config/httpClient';

export async function acceptTerms() {
  return httpClient.post('/user/accept-terms-use');
}
